<template>
  <div :class="{flex: !stacked, 'w-full':(showDate && showTime)}">
      <div class="relative">
          <div class="relative flex">
                <button v-if="!stacked" @click.prevent="toggleCalendar" class="mr-2"><icon-calendar size="sm"></icon-calendar></button>
                <input v-if="showDate" placeholder="YYYY-MM-DD" type="text" v-model="dateValue" @change="onDateChange" :class="{ border: true, rounded:true, 'px-2':true, 'py-1':true, 'mr-2':true, 'bg-yellow-200':!validDate } " @focus="showCalendar=false"/>
                <button v-if="stacked" @click.prevent="toggleCalendar"><icon-calendar size="sm"></icon-calendar></button>
            </div>
        <div :class="{absolute:true,  'mt-10':stacked, 'mt-1':!stacked }" v-if="showCalendar">
            <date-pick  :hasInputElement="false" v-model='dateValue' :format="'YYYY-MM-DD'" @input="onDateChange" :inputAttributes="inputAttributes"></date-pick>
        </div>
      </div>
      
      <input v-if="showTime" type="time" :class="{ border: true, rounded:true, 'px-2':true, 'py-1':true, 'bg-yellow-200':!validTime, 'mt-2':stacked} " @input="onTimeChange" ref="timeInput" :value="timeValue" :required="(inputAttributes['required'])"/>
  </div>
</template>

<script>
import DatePick from  'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css';
import fecha from 'fecha'
import IconCalendar from './IconCalendar.vue'

export default {
    name: "date-time-picker",

    mounted: function(){
        if(this.value){
            this.splitValueIntoDateAndTimeInputValues(this.value);
        }
    },

    components: {
        DatePick,
        IconCalendar
    },
    props: {
        value: {
            type: String,
            default: ''
        },

        inputAttributes: {
            type: Object,
            default: function(){
                return {}
            }
        },

        required: {
            type: Boolean,
        },

        stacked: {
            type: Boolean,
            default: false,
            required: false
        },

        showTime: {
            type:Boolean,
            default: true,
            required: false
        },
        showDate: {
            type:Boolean,
            default: true,
            required: false
        }
    },

    watch: {
        value: function(value){
            console.log("value watched", value);
            if(value){
                this.splitValueIntoDateAndTimeInputValues(value);
            }
            
        }
    },

    data: function(){
        return {
            dateValue: "",
            timeValue: "",
            showCalendar: false
        }
    },

    computed: {
        validTime: function(){
            let time =  fecha.parse(this.timeValue, "HH:mm")
            if(time){
                return true
            }
        },

        validDate: function(){
            let date = fecha.parse(this.dateValue, "YYYY-MM-DD")
            if( date ){
                return true;
            }
        },

    },

    methods: {

        toggleCalendar: function(){
            console.log("show calendar");
            this.showCalendar = !this.showCalendar;
            if(this.showCalendar){
                window.addEventListener("mousedown", this.onGlobalMouseDown);
            }
        },

        onGlobalMouseDown: function(e){
            console.log(e);
        },

        isValidDate: function(d) {
            return d instanceof Date && !isNaN(d);
        },

        splitValueIntoDateAndTimeInputValues: function(value){
            if(value){
                let date = new Date(value);
                console.log("date", date);

                if(this.isValidDate(date)){
                    this.dateValue = fecha.format(date, 'YYYY-MM-DD');
                    this.timeValue = fecha.format(date, 'HH:mm');
                }
                
            }
        },

        onDateChange: function(){
            console.log("onDateChange", this.dateValue);
            this.showCalendar = false;
            this.$refs.timeInput.focus();

                if(this.validDate){
                    this.updateDateTimeStringValue();
                }
                
        },

        onTimeChange: function(){
            this.timeValue = this.$refs.timeInput.value;

            this.updateDateTimeStringValue();
            
        },

        formatDateTimeValue: function(dateString, timeString){
            return dateString + " " + timeString;
        },

        

        updateDateTimeStringValue: function(){


            console.log("value emitted");
            let datetimestring = this.dateValue + "T"+this.timeValue;
        
            this.$emit('input', datetimestring);
            this.$emit('change');
        },

    }
}
</script>

<style>

    .date {
        margin-right: 1em;
    }

</style>